<template>
  <div class="admin-user">
    <el-card shadow="hover">
      <template #header>
        <div class="card-header">
          <span>管理员管理</span>
          <el-button type="primary" @click="handleAdd">添加管理员</el-button>
        </div>
      </template>
      <el-form :inline="true" :model="searchForm" class="search-form">
        <el-form-item label="用户名">
          <el-input v-model="searchForm.username" placeholder="请输入用户名"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">搜索</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="userList" style="width: 100%">
        <el-table-column prop="id" label="ID" width="80"></el-table-column>
        <el-table-column prop="username" label="用户名"></el-table-column>
        <el-table-column prop="nickname" label="昵称"></el-table-column>
        <el-table-column prop="email" label="邮箱"></el-table-column>
        <el-table-column prop="status" label="状态" width="100">
          <template #default="scope">
            <el-switch v-model="scope.row.status" @change="handleStatusChange(scope.row)"></el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="创建时间" width="180">
          <template #default="scope">
            {{ formatDate(scope.row.created_at) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150">
          <template #default="scope">
            <el-button size="small" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button size="small" type="danger" @click="handleDelete(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="currentPage"
        :page-size="pageSize"
        :page-sizes="[10, 20, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
      />
    </el-card>

    <!-- 添加/编辑管理员对话框 -->
    <el-dialog :visible.sync="dialogVisible" :title="dialogTitle" width="500px">
      <el-form ref="formRef" :model="form" :rules="formRules" label-width="80px">
        <el-form-item label="用户名" prop="username">
          <el-input v-model="form.username" placeholder="请输入用户名"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password" v-if="!form.id">
          <el-input v-model="form.password" type="password" placeholder="请输入密码"></el-input>
        </el-form-item>
        <el-form-item label="昵称" prop="nickname">
          <el-input v-model="form.nickname" placeholder="请输入昵称"></el-input>
        </el-form-item>
        <el-form-item label="邮箱">
          <el-input v-model="form.email" placeholder="请输入邮箱"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-switch v-model="form.status"></el-switch>
        </el-form-item>
        <el-form-item label="角色">
          <el-select v-model="form.role_ids" multiple placeholder="请选择角色">
            <el-option v-for="role in roleList" :key="role.id" :label="role.name" :value="role.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="handleSubmit">确定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'AdminUser',
  data() {
    return {
      userList: [],
      roleList: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      searchForm: { username: '' },
      dialogVisible: false,
      dialogTitle: '添加管理员',
      form: {},
      formRules: {
        username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        nickname: [{ required: true, message: '请输入昵称', trigger: 'blur' }]
      }
    }
  },
  mounted() {
    this.fetchUserList()
    this.fetchRoleList()
  },
  methods: {
    // 获取管理员列表
    fetchUserList() {
      try {
        const token = localStorage.getItem('adminToken')
        fetch(`/api/admin/admin-user/list?page=${this.currentPage}&pageSize=${this.pageSize}&username=${this.searchForm.username}`, {
          headers: { 'Authorization': `Bearer ${token}` }
        })
        .then(response => response.json())
        .then(data => {
          if (data.code === 0) {
            this.userList = data.data.list
            this.total = data.data.total
          }
        })
      } catch (error) {
        this.$message.error('获取管理员列表失败')
      }
    },

    // 获取角色列表
    fetchRoleList() {
      try {
        const token = localStorage.getItem('adminToken')
        fetch('/api/admin/role/list', {
          headers: { 'Authorization': `Bearer ${token}` }
        })
        .then(response => response.json())
        .then(data => {
          if (data.code === 0) {
            this.roleList = data.data
          }
        })
      } catch (error) {
        this.$message.error('获取角色列表失败')
      }
    },

    // 搜索
    handleSearch() {
      this.currentPage = 1
      this.fetchUserList()
    },

    // 分页
    handleSizeChange(size) {
      this.pageSize = size
      this.fetchUserList()
    },

    handleCurrentChange(page) {
      this.currentPage = page
      this.fetchUserList()
    },

    // 添加管理员
    handleAdd() {
      this.dialogTitle = '添加管理员'
      Object.assign(this.form, {
        username: '',
        password: '',
        nickname: '',
        email: '',
        status: true,
        role_ids: []
      })
      this.dialogVisible = true
    },

    // 编辑管理员
    handleEdit(row) {
      this.dialogTitle = '编辑管理员'
      Object.assign(this.form, { ...row })
      // 获取用户角色
      const token = localStorage.getItem('adminToken')
      fetch(`/api/admin/admin-user/detail?id=${row.id}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      })
      .then(response => response.json())
      .then(data => {
        if (data.code === 0) {
          this.form.role_ids = data.data.roles.map(role => role.id)
        }
      })
      this.dialogVisible = true
    },

    // 提交表单
    handleSubmit() {
      try {
        this.$refs.formRef.validate((valid) => {
          if (valid) {
            const token = localStorage.getItem('adminToken')
            const url = this.form.id ? '/api/admin/admin-user/update' : '/api/admin/admin-user/create'
            fetch(url, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
              },
              body: JSON.stringify(this.form)
            })
            .then(response => response.json())
            .then(data => {
              if (data.code === 0) {
                this.$message.success(this.form.id ? '更新成功' : '添加成功')
                this.dialogVisible = false
                this.fetchUserList()
              } else {
                this.$message.error(data.message)
              }
            })
          }
        })
      } catch (error) {
        this.$message.error('操作失败')
      }
    },

    // 删除管理员
    handleDelete(id) {
      this.$confirm('确定要删除该管理员吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const token = localStorage.getItem('adminToken')
        fetch('/api/admin/admin-user/delete', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({ id })
        })
        .then(response => response.json())
        .then(data => {
          if (data.code === 0) {
            this.$message.success('删除成功')
            this.fetchUserList()
          } else {
            this.$message.error(data.message)
          }
        })
      }).catch(() => {
        // 用户取消删除
      })
    },

    // 切换状态
    handleStatusChange(row) {
      try {
        const token = localStorage.getItem('adminToken')
        fetch('/api/admin/admin-user/toggle-status', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({ id: row.id, status: row.status })
        })
        .then(response => response.json())
        .then(data => {
          if (data.code !== 0) {
            row.status = !row.status
            this.$message.error(data.message)
          }
        })
      } catch (error) {
        row.status = !row.status
        this.$message.error('操作失败')
      }
    },

    // 格式化日期
    formatDate(timestamp) {
      if (!timestamp) return ''
      const date = new Date(timestamp * 1000)
      return date.toLocaleString('zh-CN')
    }
  }
}
</script>

<style scoped>
.admin-user {
  width: 100%;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.search-form {
  margin-bottom: 20px;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
</style>
